// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__ySD4a"};